import { primary } from "../../../assets/colorPallet";

export default function YearBar({ pre = "", after = "", data }) {
  return (
    <div className="flex items-center font-semibold text-center text-white mt-10 mb-10">
      <div
        style={{ backgroundColor: primary, minWidth: "110em" }}
        className="absolute left-0 w-full h-12 z-10"
      />
      <div className="z-20" style={{ minWidth: "18em" }}>
        {pre}
      </div>
      {data?.map((date) => (
        <div className="z-20" style={{ minWidth: "10em" }}>
          {date}
        </div>
      ))}
      <div className="z-20" style={{ minWidth: "25em" }}>
        {after}
      </div>
    </div>
  );
}
